 function getParticipantTemplate(data){
	
	var template =  `<div class="participantStreamPart" id="participant_agora${data.id}" >
							<div id="agora_remote_vdo${data.id}" class="video-streams h-100 stream-bg"></div>
							<div class="emojies_stream d-none" id="participant_emojie${data.id}"></div>
							<div class="raiseHandPartHolder d-none" data-id=${data.id} id="raiseHandPart${data.id}"></div>
							<div class="participantStreamName">${data.name}</div>
							<div class="cameraMicHolder" >	
								<div class="noVideoPartHolder d-none" id="partNoVideo${data.id}">
									<div class="muteVideo" ></div>
								</div>
								<div class="micMutePartHolder mutedMicPartHolder d-none" data-id=${data.id} id="partInActiveMic${data.id}"></div>
								<div class="micMutePartHolder micUnMutePartHolder d-none" data-id=${data.id} id="partActiveMic${data.id}" ></div>
							</div>
							<div class="noVideoInitialsHolder d-none" id="noVideoInitials${data.id}">
								<div class="noVideoInitials">${data.initials}</div>
							</div>
					</div>`; 
		
    return template;
}

export default getParticipantTemplate;